/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

const routesArray = [];

routesArray[routesArray.length] = {
    path: `/timed-entry/mobile/reservation/create`,
    componentName: 'MobileCreateReservationContainer',
    requireAuth: false,
    title: 'Create Reservation',
};

// Order Details
routesArray[routesArray.length] = {
    path: '/timed-entry/reservation/:reservationId/modify?',
    componentName: 'OrderDetailsPageContainer',
    title: 'Order Details',
};

routesArray[routesArray.length] = {
    path: '/timed-entry/confirmation/:reservationId',
    componentName: 'CartlessConfirmationContainer',
    requireAuth: true,
    title: 'Ticket Confirmation',
};

routesArray[routesArray.length] = {
    path: `/timed-entry/:facilityId/ticket/:tourId`,
    componentName: 'TourDetailsPageContainer',
    requireAuth: false,
    title: 'Ticket details page',
};

routesArray[routesArray.length] = {
    path: `/timed-entry/:facilityId`,
    componentName: 'FacilityPageContainer',
    requireAuth: false,
    title: 'Facility page',
};

export default routesArray;
